import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = ["rowspan"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "وقت الفصحة", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_material = _resolveComponent("icon-material")!

  return (_ctx.model)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.model)
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              colspan: _ctx.model ? _ctx.model.sessionCount : 1
            }, [
              _createVNode(_component_icon_material, {
                model: _ctx.model,
                teacher: _ctx.teacher
              }, null, 8, ["model", "teacher"])
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.teacher)
          ? (_openBlock(), _createElementBlock("td", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.breakTime)
          ? (_openBlock(), _createElementBlock("td", {
              key: 1,
              rowspan: _ctx.daysCount,
              class: "breakTime"
            }, _hoisted_5, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ], 64))
}